import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  user: {
    tenantId: "",
    loginId: "",
    userId: "",
    userName: "",
    userFamilyName: "",
    userFirstName: "",
    email: "",
    branchKey: "",
    depKey: "",
    contactedShowFlag: false,
    isLoggedIn: false,
    mfaFlag: false,
    validIpFlag: false,
    profileInitials: null,
    needToChangePassFlag: false,
    defaultPassword: "",
    personalDataManagerFlag: null,
    printPermissionFlag: false,
    csvOutputPermission: false,
    labelOutputPermission: false,
    resultOutputPermission: false,
    customerViewRestrictionFlag: false,
    policySearchCsvOutputFlag: false,
    tenantTypeCd: "",
    branchCustomerViewRestrictionFlag: false,
    intentionApprovalFlowFlag: false,
    contractListOutputFlag: false
  },
  menuList: [],
  urlList: []
};

const mutations = {
  setUserInfo(state, payload) {
    console.log(payload);
    if (payload != null) {
      state.user.tenantId = payload.tenantId;
      state.user.loginId = payload.loginId;
      state.user.userId = payload.userId;
      state.user.userName = payload.userName;
      state.user.userFamilyName = payload.userFamilyName;
      state.user.userFirstName = payload.userFirstName;
      state.user.email = payload.email;
      state.user.branchKey = payload.branchKey;
      state.user.depKey = payload.depKey;
      state.user.contactedShowFlag = payload.contactedShowFlag;
      state.user.mfaFlag = payload.mfaFlag;
      state.user.validIpFlag = payload.validIpFlag;
      state.user.needToChangePassFlag = payload.needToChangePassFlag;
      state.user.defaultPassword = payload.defaultPassword;
      state.user.personalDataManagerFlag = payload.personalDataManagerFlag;
      state.user.printPermissionFlag = payload.printPermissionFlag;
      state.user.csvOutputPermission = payload.csvOutputPermission;
      state.user.labelOutputPermission = payload.labelOutputPermission;
      state.user.resultOutputPermission = payload.resultOutputPermission;
      state.user.customerViewRestrictionFlag = payload.customerViewRestrictionFlag;
      state.user.policySearchCsvOutputFlag = payload.policySearchCsvOutputFlag;
      state.user.tenantTypeCd = payload.tenantTypeCd;
      state.user.branchCustomerViewRestrictionFlag = payload.branchCustomerViewRestrictionFlag;
      state.user.intentionApprovalFlowFlag = payload.intentionApprovalFlowFlag;
      state.user.contractListOutputFlag = payload.contractListOutputFlag;
    } else {
      state.user.tenantId = "";
      state.user.loginId = "";
      state.user.userId = "";
      state.user.userName = "";
      state.user.userFamilyName = "";
      state.user.userFirstName = "";
      state.user.email = "";
      state.user.branchKey = "";
      state.user.depKey = "";
      state.user.contactedShowFlag = false;
      state.user.isloggedin = false;
      state.user.mfaFlag = false;
      state.user.validIpFlag = false;
      state.user.needToChangePassFlag = false;
      state.user.personalDataManagerFlag = false;
      state.user.printPermissionFlag = false;
      state.user.csvOutputPermission = false;
      state.user.labelOutputPermission = false;
      state.user.resultOutputPermission = false;
      state.user.customerViewRestrictionFlag = false;
      state.user.policySearchCsvOutputFlag = false;
      state.user.tenantTypeCd = "";
      state.user.branchCustomerViewRestrictionFlag = false;
      state.user.intentionApprovalFlowFlag = false;
      state.user.contractListOutputFlag = false;
    }
  },
  setLoginStatus(state, isLoggedIn) {
    state.user.isLoggedIn = isLoggedIn;
  },
  setProfileInitials(state) {
    state.user.profileInitials =
      state.user.userFamilyName.substring(0, 1) + state.user.userFirstName.substring(0, 1);
  },
  setMenu(state, payload) {
    if (payload != null) {
      state.menuList = payload;
    }
  },
  setUrl(state, payload) {
    if (payload != null) {
      state.urlList = payload;
    }
  }
};

const actions = {
  setUserState({ commit }, data) {
    commit("setUserInfo", data);
    if (data != null) {
      commit("setMenu", data.accessibleMenulList);
      commit("setUrl", data.accessibleUrlList);
    }
    commit("setProfileInitials");
  },
  setLoginStatus({ commit }, loginStatus) {
    commit("setLoginStatus", loginStatus);
  }
};

const store = new Vuex.Store({
  state,
  actions,
  mutations
});

export default store;
